import { render } from "./FarmOsFarm.vue?vue&type=template&id=570eb12a&scoped=true"
import script from "./FarmOsFarm.vue?vue&type=script&lang=js"
export * from "./FarmOsFarm.vue?vue&type=script&lang=js"

import "./FarmOsFarm.vue?vue&type=style&index=0&id=570eb12a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570eb12a"]])

export default __exports__